/**
 * Scroll reveal (feature list v1.2) — helper condiviso come theme-events.js.
 *
 * Attivo solo con body[data-animations] (theme setting) e senza preferenza
 * di riduzione del movimento. Le classi di partenza le mette QUESTO script:
 * senza JavaScript nessuna sezione parte nascosta.
 */
(function () {
  if (!document.body.hasAttribute('data-animations')) return;
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;

  var sections = document.querySelectorAll('.shopify-section[id^="shopify-section-template-"]');
  if (!sections.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  sections.forEach(function (section) {
    var rect = section.getBoundingClientRect();
    if (rect.top > window.innerHeight) {
      section.classList.add('reveal-init');
      observer.observe(section);
    }
  });
})();
